export default "__VITE_ASSET__83c31c28__"